import React from "react";
import { twMerge } from "tailwind-merge";
import Card from "./Card";

/**
 * Quiet empty / zero state.
 */
export default function EmptyState({
  title,
  description,
  action,
  className = "",
  icon = null,
  /** Feed-style compact empty card (16px title, tighter padding). */
  compact = false,
  ...rest
}) {
  return (
    <Card
      className={twMerge(compact ? "p-6 text-center" : "p-8 sm:p-10 text-center", className)}
      data-testid={rest["data-testid"]}
      {...rest}
    >
      {icon ? <div className="mb-4 flex justify-center text-ink/35">{icon}</div> : null}
      {title ? (
        <h2
          className={
            compact
              ? "font-ui font-semibold text-[16px] leading-snug text-ink/80 break-words [overflow-wrap:anywhere]"
              : "font-ui font-semibold text-[18px] sm:text-[20px] text-ink text-balance"
          }
        >
          {title}
        </h2>
      ) : null}
      {description ? (
        <p className="mt-2 mx-auto max-w-sm text-[14px] font-normal text-ink/55 text-pretty">
          {description}
        </p>
      ) : null}
      {action ? <div className="mt-6 flex justify-center">{action}</div> : null}
    </Card>
  );
}
